import type { App } from 'vue';
import FHeading from './f-heading.vue';

export declare interface Heading {
  install: (app: App) => void;
}

export function useHeading() : Heading {
  return {
    install: (app: App) => {
      app.component('FHeading', FHeading);
    },
  };
}